import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const SurinameFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				x='0.25'
				y='0.25'
				width='19.5'
				height='13.5'
				rx='1.75'
				fill='white'
				stroke='#F5F5F5'
				strokeWidth='0.5'
			/>
			<mask
				id='mask0_2332_15919'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					x='0.25'
					y='0.25'
					width='19.5'
					height='13.5'
					rx='1.75'
					fill='white'
					stroke='white'
					strokeWidth='0.5'
				/>
			</mask>
			<g mask='url(#mask0_2332_15919)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 2.8H20V0H0V2.8Z'
					fill='#43924C'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H20V11.2H0V14Z'
					fill='#43924C'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 9.33329H20V4.66663H0V9.33329Z'
					fill='#CD153A'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M10.0001 8.19002L8.6006 9.12106L9.07168 7.52898L7.73567 6.51232L9.4263 6.4594L10.0001 4.90002L10.5739 6.4594L12.2645 6.51232L10.9285 7.52898L11.3996 9.12106L10.0001 8.19002Z'
					fill='#F5D24B'
				/>
			</g>
		</svg>
	);
};

export default SurinameFlagIcon;
